import store from "../../../../../../stores/application/index.js.erb";
import axios from "axios";

const get_token = () => {
  const token = document.querySelector('[name=csrf-token]').content;
  return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
};

const showErrorMessage = (message) => {
  return store.dispatch("error_portfolio/addError", {
    type: "Error Server",
    message: message,
    context: "Error Server",
    show: true
  });
};

const errorCode = (errorResponse) => {
  if (errorResponse.status === 404) return showErrorMessage(errorResponse.data.error.message)

  if (errorResponse.status === 422) return showErrorMessage(errorResponse.data.error.message)

  return showErrorMessage("Неизвестная ошибка сервера");
}

const PastStudentStatementsApi = {

  async indexByUrl(url) {
    get_token();
    try {
      return await axios.get(url);
    } catch (error) {
      errorCode(error.response);
      return null;
    }
  },

  async index({meeting, statement}) {
    get_token();
    try {
      return await axios.get(`/scholarship/meeting/meetings/${meeting}/competitions/${statement}/past_student_scholarship_competitions`);
    } catch (error) {
      errorCode(error.response);
      return null;
    }
  },

  async showByUrl(url) {
    get_token();
    try {
      return await axios.get(url);
    } catch (error) {
      errorCode(error.response);
      return null;
    }
  },

  async show({meeting, statement, past_statement}) {
    get_token();
    try {
      return await axios.get(`/scholarship/meeting/meetings/${meeting}/competitions/${statement}/past_student_scholarship_competitions/${past_statement}`);
    } catch (error) {
      errorCode(error.response);
      return null;
    }
  },
};

export default PastStudentStatementsApi;